(()=>{
 function previewCountFor(variant){
  let value=Math.floor(Number(variant.id)/32768);
  value^=value<<13;value^=value>>>17;value^=value<<5;
  return 2+(value>>>0)%4;
 }
 function update(section,variant){
  if(!section||!variant)return;
  const stock=section.querySelector('[data-mc-store-stock]');if(!stock)return;
  let counts={};try{counts=JSON.parse(section.querySelector('[data-mc-variant-stock]')?.textContent||'{}');}catch(error){}
  const entry=counts[String(variant.id)]||{};
  const draftPreview = section.getAttribute('data-product-id') === '15563357159809'
    && window.Shopify?.theme?.id === 190761271681
    && window.Shopify.theme.role === 'unpublished'
    && window.Shopify.previewMode === true;
  let count = entry.count;
  if(draftPreview&&variant.available)count=previewCountFor(variant);
  const limited=variant.available&&Number.isInteger(count)&&count>0&&count<=9;
  stock.style.removeProperty('--mc-stock-fill');
  if(limited)stock.style.setProperty('--mc-stock-fill',Math.max(12,Math.min(30,count*6))+'%');
  stock.replaceChildren();
  if(limited){const text=document.createElement('span');text.textContent='LIMITED STOCK · Only '+count+' '+(count===1?'item':'items')+' left';stock.append(text);}
  else stock.textContent=variant.available?'Available to order':'Currently unavailable';
  stock.classList.toggle('mc-stock-limited',limited);
 }
 function initialize(){document.querySelectorAll('.product-section').forEach(section=>{try{const id=section.querySelector('[data-product-select]')?.value;const variant=JSON.parse(section.querySelector('[data-variant-json]')?.value||'[]').find(v=>String(v.id)===id);update(section,variant);}catch(error){}});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
 document.addEventListener('shopify:section:load',initialize);
 document.addEventListener('variant:change',event=>{
  const variant=event.detail?.variant;
  const section=Array.from(document.querySelectorAll('.product-section')).find(node=>{try{return JSON.parse(node.querySelector('[data-variant-json]')?.value||'[]').some(v=>v.id===variant?.id);}catch(error){return false;}});
  update(section,variant);
 });
})();

(() => {
  function tomorrowLabel(now, timeZone) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(now);
    const value = type => Number(parts.find(part => part.type === type).value);
    const tomorrow = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + 1));
    const weekday = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short' }).format(tomorrow);
    return weekday + ' ' + tomorrow.getUTCDate();
  }
  function refresh() {
    document.querySelectorAll('[data-mc-dispatch-date]').forEach(node => {
      try {
        const date = tomorrowLabel(new Date(), node.dataset.mcDispatchTimezone);
        const text = node.dataset.mcDispatchTemplate.replace('__DATE__', date);
        if (node.textContent !== text) node.textContent = text;
      } catch (error) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  window.setInterval(refresh, 60000);
})();
